export default {
  type: 'superscript',
  tagName: 'sup'
}
